import React, { useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { Box, Button, Grid } from '@material-ui/core';
import { connect } from "react-redux"
import { ApplicationState } from "../../redux/reducers";
import { loadSucursales as loadSucursalesAction } from "../../redux/actions/sucursalActions";
import { useEffect } from "react";
import Step, { IStep } from "../stepper/Step";
import { loadCategoriasServicios } from "../../redux/actions/servicioAdicionalActions";
import { loadParametros } from "../../redux/actions/parametroActions";
import { loadTiposSeguroObservacion } from "../../redux/actions/tipoSeguroObservacionActions";
import { ICliente } from "../../entities/catalogos/ICliente";
import { IUsuario } from "../../entities/catalogos/IUsuario";
import { useHistory } from "react-router-dom";
import { Solicitud } from '../../entities/solicitudes/Solicitud';
import StepSolicitud from '../stepper/StepSolicitud';
import { initialSolicitud } from '../../redux/reducers/solicitudReducer';
import { setSolicitud, setSolicitudCopia } from '../../redux/actions/solicitudActions';
import { setRecoleccionDestino, setRecoleccionOrigen } from '../../redux/actions/recoleccionActions';
import { saveMercancias } from '../../redux/actions/mercanciaActions';
import { setUsuario } from '../../redux/actions/usuarioActions';
import { initialRecoleccionState } from '../../redux/reducers/recoleccionReducer';
import { initialMercancia } from '../../redux/reducers/mercanciaReducer';
import useCommonApi from '../../api/useCommonApi';
import { cerrarSesionEnServidor } from '../../api/sesionPortal';
import swal from 'sweetalert2'
import { enums } from "../../enums/enums";
import { traducirButton, traducirLabel, traducirMessage } from  "../../blocks/traductor";
import SelectControl from '../controls/SelectControl';
import { Sucursal } from '../../entities/catalogos/Sucursal';
import { IParametro } from '../../redux/types/parametroActionTypes';
import { ICategoriaServicio } from '../../redux/types/servicioAdicionalType';
import { ICatalogo } from '../../entities/catalogos/ICatalogo';


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        title: {
            flexGrow: 1,
        },
        header: {
            width: "100%",
            height: '48px',
            background: "url('/image/banner.png') no-repeat center center",
            boxShadow: "none"
        },
        toolbar: {
            minHeight: '48px'
        },
        back: {
            backgroundColor: "transparent"
        },
        buttonBack: {
            color: "#19754e",
            fontWeight: 600,
            fontSize: "16px"
        }
    }),
);

interface IProps {
    tipo: string,
    guardandoSS?: boolean
}

interface StateProps {
    cliente: ICliente
    usuario: IUsuario
    solicitud: Solicitud
    solicitudCopia: Solicitud
    changeIdioma: (idiomaId: string) => void,
    sucursales: Sucursal[], 
    parametros: IParametro[],
    categoriasServicios: ICategoriaServicio[],
    tipoSeguroObservacion: ICatalogo[]
}

interface DispatchProps {
    //  loadPaises: typeof loadPaises
    loadSucursales: typeof loadSucursalesAction

    loadCategoriasServicios: typeof loadCategoriasServicios
    loadParametros: typeof loadParametros
    loadTiposSeguroObservacion: typeof loadTiposSeguroObservacion
    setSolicitud: typeof setSolicitud
    setSolicitudCopia: typeof setSolicitudCopia
    saveMercancias: typeof saveMercancias
    setRecoleccionOrigen: typeof setRecoleccionOrigen
    setRecoleccionDestino: typeof setRecoleccionDestino
    setUsuario: typeof setUsuario
}

type Props = IProps & StateProps & DispatchProps

const Header = (props: Props) => {
    let steps: IStep[] = [

        { id: 0.5, nombre: traducirLabel(70) }, // "Datos de Contacto" }, 
        {id: 1, nombre: traducirLabel(241) }, // "Proyecto" },
        { id: 2, nombre: traducirLabel(223) }, // "Origen y Destino" },
        { id: 3, nombre: traducirLabel(71) }, // "Datos de Mercancía" },
        { id: 4, nombre: traducirLabel(278) }, // "Servicios Adicionales" },
        { id: 5, nombre: traducirLabel(72) }, // "Datos del Cliente" },
        { id: 7, nombre: "Markup" },
        { id: 8, nombre: traducirLabel(58), esUltimoPaso: true }, // "Cotización", esUltimoPaso: true },
    ];
    
    let stepsSolicitud: IStep[] = [
        { id: 0, nombre: traducirLabel(58) }, // "Cotización" },
        { id: 1, nombre: traducirLabel(241) }, // "Proyecto" },
        { id: 1.1, nombre: traducirLabel(127) }, // "Facturador" },
        { id: 2, nombre: traducirLabel(223) }, // "Origen y Destino" },
        { id: 3, nombre: traducirLabel(71) }, // "Datos de Mercancía" },
        { id: 4, nombre: traducirLabel(278) }, // "Servicios Adicionales" },
        { id: 5, nombre: traducirLabel(72) }, // "Datos del Cliente" },
        { id: 7, nombre: "Markup" },
        { id: 9, nombre: traducirLabel(284), esUltimoPaso: true }, // "Solicitud Servicio", esUltimoPaso: true },
    ];
        
    const classes = useStyles();
    let pasos = steps.filter(s => (s.id !== 7));
    pasos = pasos.filter(a => (props.usuario.esInvitado && a.id !== 7 && a.id !== 5) || !props.usuario.esInvitado);
    pasos = pasos.filter(a => (!props.usuario.esInvitado && a.id !== 0.5) || props.usuario.esInvitado);
    let pasosSolicitud = stepsSolicitud.filter(s => ((s.id !== 7) && (s.id !== 1.1 || props.cliente.habilitarClienteLogistico) ));
    pasosSolicitud = pasosSolicitud.filter(a => (props.usuario.esInvitado && a.id !== 7) || !props.usuario.esInvitado);
    if ((props.cliente.clienteCreditoProyecto && props.cliente.clienteCreditoProyecto?.length === 1 &&
        props.cliente.clienteCreditoProyecto[0].clienteCreditoProyectoID === 0)) {
        pasos = pasos.filter(s => (s.id !== 1));
        pasosSolicitud = pasosSolicitud.filter(s => (s.id !== 1));
    }
    const apiSource = useCommonApi();

    if (props.tipo === 'cotizacion') {
        if (!props.solicitud.completada) {
            pasos = pasos.filter(s => (s.id !== 0));
        }
        if (props.solicitud.completada && props.solicitud.modificar) {
            pasos = pasos.filter(s => (s.id !== 0));
        }
        if (!props.solicitud.completada && !props.solicitud.modificar && props.solicitud.id === 0) {
            pasos = pasos.filter(s => (s.id !== 0));
        }
        /* if(props.solicitud.completada && !props.solicitud.modificar && props.solicitud.id > 0){
             let esSolicitud = pasos.filter(s => (s.id === 7));
             esSolicitud[0].nombre ="Solicitud de Servicio";
         }*/
    }
    if (props.tipo === 'solicitud servicio') {
        if (props.solicitud.id === 0 && !props.solicitud.cotizacionId) {
            pasosSolicitud = pasosSolicitud.filter(s => (s.id !== 0));
        }
        if (props.solicitud.id > 0 && !props.solicitud.cotizacionId) {
            pasosSolicitud = pasosSolicitud.filter(s => (s.id !== 0));
        }
    }


    const [usuarioInvitado, setUsuarioInvitado] = useState(false);
    const [ultimoPaso, setUltimoPaso] = useState(false);
    const history = useHistory();
    const [lang, setLang] = useState({ id: 'es-MX' });

    if (props.solicitud.tipoSolicitud === "solicitud servicio" && props.solicitud.seccionId === enums.estatusSolicitud.resumen && props.solicitud.seccionId === 9 && !ultimoPaso) {
        setUltimoPaso(true);
    }
    if (props.solicitud.tipoSolicitud === "cotizacion" && props.solicitud.completada && props.solicitud.seccionId ===8 && !ultimoPaso) {
        setUltimoPaso(true);
    }

    if (props.solicitud.tipoSolicitud === "solicitud servicio" && props.solicitud.seccionId !== 9 && ultimoPaso) {
        setUltimoPaso(false);
    }
    if (props.solicitud.tipoSolicitud === "cotizacion" && props.solicitud.seccionId !==8 && ultimoPaso) {
        setUltimoPaso(false);
    }

    const timerMensajeSolicitudGenerada = () => {
        return new Promise((resolve, reject) => {
            setTimeout(function () {
                resolve(true);
            }, 500);
        })
    }

    const back = () => {

        if (props.solicitud.seccionId === enums.estatusSolicitud.resumen) {
            //setUltimoPaso(false);
            swal.fire({
                titleText: traducirLabel(49), // 'Confirmar Solicitud de Servicio',
                text: traducirMessage(26), // "¿Desea generar la Solicitud de Servicio?",
                type: 'warning',
                showConfirmButton: true,
                showCancelButton: true,

                cancelButtonAriaLabel: traducirButton(6), // 'Cancelar',
                confirmButtonAriaLabel: traducirButton(8), // 'Generar',
                preConfirm: () => {
                    timerMensajeSolicitudGenerada().then(() => {
                        localStorage.removeItem('ClasificacionAreaServicioOrigen');
                        localStorage.removeItem('ClasificacionAreaServicioDestino');
                        localStorage.removeItem("mercanciasDatos");
                        swal.fire({
                            titleText: traducirMessage(15), // '¡Gracias por confiar en nosotros!',
                            text: traducirMessage(266).replace("#####", props.solicitud.numGuia), // "Tu solicitud de servicio " + props.solicitud.numGuia + " ha sido generada con éxito",
                            type: 'success',
                        });
                    });
                    history.push("/");
                }
            });

        }
        else
            history.push("/");
    }

    const nuevaCotizacion = () => {
        const nuevaCotizacion = new Solicitud(initialSolicitud);

        props.setSolicitud(nuevaCotizacion);
        props.setSolicitudCopia(nuevaCotizacion);
        props.setRecoleccionOrigen(initialRecoleccionState);
        props.setRecoleccionDestino(initialRecoleccionState);
        props.saveMercancias([initialMercancia]);
        props.setUsuario({ ...props.usuario });

        history.push("/nueva-cotizacion");

    }

    const getParametros = async () => {
        const result = await apiSource.obtenerAsync<any>('parametro/active');
        return result;
    }

    useEffect(() => {
        if(props.categoriasServicios?.length===0)
            props.loadCategoriasServicios();
        if(props.parametros?.length===0)
            props.loadParametros();
        if(props.tipoSeguroObservacion?.length===0)
            props.loadTiposSeguroObservacion();
        if (props.usuario.esInvitado) {
            setUsuarioInvitado(true);
        }


    }, []);
    useEffect(() => {
        if (props.cliente.empresaID > 0 && props.sucursales?.length === 0) {
            props.loadSucursales(props.cliente.empresaID);
        }
    }, [props.cliente.empresaID]);

    const logOut = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("usuarioId");
        localStorage.removeItem("clienteId");
        localStorage.removeItem("tipo_usuario");
        localStorage.removeItem("usuario_nombre");
        
        localStorage.removeItem('ClasificacionAreaServicioOrigen');
        localStorage.removeItem('ClasificacionAreaServicioDestino');
        localStorage.removeItem("mercanciasDatos");
        localStorage.removeItem("verCargaMasiva");
        localStorage.removeItem("verGuiasPortalExterno");

        cerrarSesionEnServidor(apiSource).then(() => {
            sessionStorage.removeItem("token");
            return getParametros();
        }).then(data => {
            let loginUrl = data.find(a => a.nombre === 'URL Login Portal Nuevo');

            if (loginUrl !== undefined) {
                window.location.replace(loginUrl.valor);
            }
            else {
                history.push("/getting-started/installation/");
            }
        })
    }
    const actualizarIdioma = async (e) => {
        //setLoading(true);
        const usuarioNombreStorage = localStorage.getItem("usuario_nombre");
        const clienteStorage = localStorage.getItem("clienteId");
        const params = {
            clienteID: clienteStorage,
            usuario: usuarioNombreStorage,
            idioma: e.target.value
        };
        const result = await apiSource.postAsync<any>('idioma/change', params);
        let confirmChangeLang=false;
        if (props.usuario.esInvitado) {
            swal.fire({
                titleText: traducirMessage(11), // '¡Aviso!',
                html: traducirMessage(303), // "Si cambias el idioma es posible que se pierda la información de esta etapa. <br><b>¿Quieres seguir?</b>",
                type: 'warning',
                showConfirmButton: true,
                showCancelButton: true,

                cancelButtonAriaLabel: "NO", // 'Cancelar',
                confirmButtonAriaLabel: "SI", // 'Generar',
                preConfirm: () => {
                    setLang({ ...lang, id: e.target.value });
                    localStorage.removeItem("idioma");
                    localStorage.setItem("idioma", e.target.value);
                    if (result.length > 0) {
                        localStorage.removeItem("etiquetas");
                        localStorage.setItem("etiquetas", JSON.stringify(result));
                        props.changeIdioma(e.target.value);
                    }
                }
            });
        }

        if (!props.usuario.esInvitado) {
            confirmChangeLang = true;
        }    
        
        if(confirmChangeLang){
            setLang({ ...lang, id: e.target.value });
            localStorage.removeItem("idioma");
            localStorage.setItem("idioma", e.target.value);
            if (result.length > 0) {
                localStorage.removeItem("etiquetas");
                localStorage.setItem("etiquetas", JSON.stringify(result));
                window.location.reload();
            }
        }
    };

    return (<>
        <AppBar position="static" color='default' className={classes.header}>
            <Toolbar className={classes.toolbar}>
                <div className={classes.title}>
                    <img src="/image/almex-logo.png" alt={""} />
                </div>

                <Breadcrumbs separator="|" aria-label="breadcrumb">
                    <Typography color="textPrimary">
                        {traducirLabel(20)}, <b>{props.usuario.nombre}</b>
                    </Typography>
                    {props.usuario.esInvitado &&
                        <Box>
                        {localStorage.getItem("idioma")==='en-US' &&
                            <SelectControl name="lang" source="idioma/many" label={traducirLabel(322)} onChange={actualizarIdioma}
                            value='en-US' />
                        }
                        {localStorage.getItem("idioma")!=='en-US' &&
                            <SelectControl name="lang" source="idioma/many" label={traducirLabel(322)} onChange={actualizarIdioma}
                            value='es-MX' />
                        }
                            
                    </Box>
                    }
                    <Button onClick={logOut}>
                        {traducirButton(11)}
                    </Button>
                </Breadcrumbs>
            </Toolbar>
        </AppBar>

        {<Grid container justify="center" alignItems="center" className="step-section">
            {props.tipo === 'cotizacion' && pasos.map((s) => {
                return <Step key={s.id} id={s.id} nombre={s.nombre} esUltimoPaso={s.esUltimoPaso} cliente={props.cliente} />
            })}

            {props.tipo === 'solicitud servicio' && pasosSolicitud.map((s) => {
                return <StepSolicitud key={s.id} id={s.id} nombre={s.nombre} esUltimoPaso={s.esUltimoPaso} cliente={props.cliente} disabled={props.guardandoSS}/>
            })}

        </Grid>}

        {!props.usuario.esInvitado &&
            <Grid container className={classes.back}>
                <Grid item sm={12} >

                    <Box display="flex" justifyContent="flex-end" >

                        <Button className={classes.buttonBack} onClick={() => back()}>
                            {/* Volver a página principal */
                                traducirButton(9)}
                        </Button>

                    </Box>

                </Grid>
            </Grid>
        }
        {props.usuario.esInvitado &&
            <Grid container className={classes.back}>
                <Grid item sm={12} >

                    <Box display="flex" justifyContent="flex-end" >

                        <Button className={classes.buttonBack} onClick={() => nuevaCotizacion()}>
                            {/* generar nueva cotización */
                                !props.usuario.esInvitado ? traducirButton(10) : ''}
                        </Button>

                    </Box>

                </Grid>
            </Grid>
        }

    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente,
    usuario: state.usuario,
    solicitud: state.solicitud,
    solicitudCopia: state.solicitudCopia,
    idiomaId: state.idioma,
    sucursales: state.sucursales,
    parametros: state.parametros,
    tiposSeguroObservacion: state.tiposSeguroObservacion,
    categoriasServicios: state.categoriasServicios
});

const mapDispatchToProps = {
    // loadPaises: loadPaises,
    loadSucursales: loadSucursalesAction,

    loadCategoriasServicios: loadCategoriasServicios,
    loadParametros: loadParametros,
    loadTiposSeguroObservacion: loadTiposSeguroObservacion,

    setSolicitud: setSolicitud,
    setSolicitudCopia: setSolicitudCopia,
    setRecoleccionOrigen: setRecoleccionOrigen,
    setRecoleccionDestino: setRecoleccionDestino,
    saveMercancias: saveMercancias,
    setUsuario: setUsuario
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);

